<template>
    <div class="flex flex-col gap-4 mt-[24px]"
        :class="{
            'border border-red-error px-[16px] -mx-[16px] py-[13px]': hasErrorState,
        }"
    >
        <div v-for="subOption in initialsOptions"
            :key="subOption.name"
        >
            <div
                class="mb-[16px] font-semibold text-[16px] font-oceanside"
                :class="{
                    'text-red-error': hasErrorState,
                }"
            >
                {{ $t('SELECT_TEXT_COLOR') }}
            </div>
            <step-options-my-palette
                class="my-[24px] overflow-hidden"
                :class="hasErrorState ? 'px-[20px]' : '-mx-[40px] px-[40px]'"
                v-if="isAnyPaintfillSelected"
                :selected-color="subOption.selectedColor"
                @updateColorIsSelected="handleUpdateSelectedColor(subOption.name, $event)"
            />
            <master-palette
                select-mode="checkmark"
                :selected-color="subOption.selectedColor"
                :has-error-state="hasErrorState"
                :limit-by="subOption.name"
                @updateColorIsSelected="handleUpdateSelectedColor(subOption.name, $event)"
            />
        </div>
    </div>
</template>

<script>
    import allStores from '../stores/all';
    import MasterPalette from './MasterPalette.vue';
    import StepOptionsMyPalette from './StepOptionsMyPalette.vue';

    export default {
        mixins: [allStores],

        components: {
            MasterPalette,
            StepOptionsMyPalette,
        },

        emits: ['color-selected'],

        data() {
            return {
                activeSubOptionName: null,
            };
        },

        props: {
            hasErrorState: {
                type: Boolean,
                default: false,
            },
        },

        computed: {
            initialsOptions() {
                return this.customizerStore?.uiStepSubOptions?.frontInitials || [];
            },

            isAnyPaintfillSelected() {
                return this.customizerStore.isAnyPaintfillSelected();
            },
        },

        methods: {
            handleUpdateSelectedColor(name, paletteValue) {
                const result = this.customizerStore?.requestStepSubOptionColorChange(name, paletteValue);

                if (result) {
                    this.$emit('color-selected', name);
                }
            },
        },
    };
</script>
